import { Mixins, Component } from 'vue-property-decorator';
import GroupGridsExcelDown from '@/components/authority/mixins/groupExcelWown';
import router from '@/routes/index';
import { escapeHtml} from '@/utils/commonUtils';
@Component
export default class GroupsListColumns extends Mixins(GroupGridsExcelDown) {
  public groupsListColumns: any = {
    '권한그룹명': {
      header: '권한그룹명',
      name: 'name',
      align: 'left',
      minWidth: 199,
      renderer: (props): any => {
        return this.groupNmLinkRender(props);
      }
      /*formatter: function (data: any): any {
        return `<a href="/authorityGroup/modifyForm/${data.row.no}">${data.value}</a>`
      }*/
    },
    '권한그룹설명': {
      header: '권한그룹설명',
      name: 'description',
      align: 'left',
      minWidth: 259,
      formatter: function (data: any): any {
        if (data.value) {
          return escapeHtml(data.value);
        } else {
          return ''
        }
      }
    },
    '권한보유자': {
      header: '권한보유자',
      name: 'adminCount',
      align: 'center',
      minWidth: 69,
      formatter: function (data: any): any {
        if (data.value) {
          return `<a href="javascript:;" data-index=${data.row.no} class="group-name-grid">${data.value + '명'}</a>`
        }
        if (data.value === 0) {
          return '0명'
        }
      },
       copyOptions: {
        useFormattedValue: false,
      }
    },
    '개인정보목록조회': {
      header: '개인정보 목록조회',
      name: 'permitsPrivateInformation',
      align: 'center',
      minWidth: 89,
      formatter: function (data: any): any {
        if (data.value === true) {
          return 'Y'
        } else {
          return 'N'
        }
      }
    },
    '상품담당자': {
      header: '상품담당자',
      name: 'allowsMarketingDirection',
      align: 'center',
      minWidth: 69,
      formatter: function (data: any): any {
        if (data.value === true) {
          return 'Y'
        } else {
          return 'N'
        }
      }
    },
    '등록자': {
      header: '등록자',
      name: 'creatorName',
      align: 'center',
      minWidth: 109,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        }
      }
    },
    '등록일시': {
      header: '등록일시',
      name: 'creationDateTime',
      align: 'center',
      minWidth: 139,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        }
      }
    },
    '최종수정자': {
      header: '최종수정자',
      name: 'modifierName',
      align: 'center',
      minWidth: 139,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        }
      }
    },
    '최종수정일시': {
      header: '최종수정일시',
      name: 'modificationDateTime',
      align: 'center',
      minWidth: 144,
      formatter: function (data: any): any {
        if (data.value) {
          return data.value
        }
      }
    }
  }

  private groupNmLinkRender(props: any): any {
    const text = props.text || props.value.toString();
    let rowData = props.grid.getRow(props.rowKey);
    let path = '/authorityGroup/modifyForm/'+ rowData.no;
    const onMouseDown = (event: Event): void => {
      event.preventDefault();
      router.push({path: path});
    };
    const div = document.createElement('div');
    const aTag = document.createElement('a');
    aTag.innerHTML = escapeHtml(text.toString());
    aTag.addEventListener('mousedown', onMouseDown);
    aTag.setAttribute('href','javascript:void();')
    div.setAttribute('class','tui-grid-cell-content');
    div.append(aTag);
    return {
      getElement(): HTMLElement {
        return div;
      },
      render(): void {},
      beforeDestroy(): void {
        aTag.removeEventListener('mousedown', onMouseDown);
      }
    };
  }
}